import React from 'react';
import { useFetchArticleCategories } from './hooks/useFetchArticleCategories';
import { useArticleContext } from './hooks/useArticleContext';
import { ArticleProvider } from './reducer/ArticleProvider';
import { LoadingIndicator } from '@xolv-mybrightlink/common';

const ArticleInit = (props: { children: React.ReactNode }) => {
  const [state] = useArticleContext();
  useFetchArticleCategories();
  if (state.initial) {
    return <LoadingIndicator fullHeight />;
  }
  return <>{props.children}</>;
};

export const ArticleRoute = (props: { children: React.ReactNode }) => {
  return (
    <ArticleProvider>
      <ArticleInit>{props.children}</ArticleInit>
    </ArticleProvider>
  );
};
